import React, { FunctionComponent } from 'react';
import { StyleSheet, TouchableOpacity, View } from 'react-native';
import SkipBackwardIcon from '../../../assets/images/home-workouts/music-back.svg';
import SkipForwardIcon from '../../../assets/images/home-workouts/music-forward.svg';
import PauseIcon from '../../../assets/images/home-workouts/music-pause.svg';
import PlayIcon from '../../../assets/images/home-workouts/music-play.svg';
import Theme from '../../../theme';
import { defaultScale } from '../../../utils/scaling';
import { IPlayerState } from '../Music';
import { disabledOpacity } from './IconButton';

interface IProps {
  isPlaying: boolean;
  skipForward: () => void;
  skipBackward: () => void;
  play: () => void;
  pause: () => void;
  canSkipNext: boolean;
  canSkipPrevious: boolean
}

export const MusicControlButtons: FunctionComponent<IProps> = ({
                                                                 isPlaying,
                                                                 skipForward,
                                                                 skipBackward,
                                                                 play,
                                                                 pause,
                                                                 canSkipPrevious,
                                                                 canSkipNext,
                                                               }) => {

  const musicControlIconSize = {
    height: defaultScale(60),
    width: defaultScale(60),
  };

  const skipBackButton = (
    <TouchableOpacity onPress={skipBackward} disabled={!canSkipPrevious}>
      <SkipBackwardIcon color={Theme.WHITE}
                        opacity={canSkipPrevious ? 1 : disabledOpacity} {...musicControlIconSize} />
    </TouchableOpacity>
  );

  const skipForwardButton = (
    <TouchableOpacity onPress={skipForward} disabled={!canSkipNext}>
      <SkipForwardIcon color={Theme.WHITE}
                       opacity={canSkipNext ? 1 : disabledOpacity} {...musicControlIconSize} />
    </TouchableOpacity>
  );

  return (
    <View style={styles.musicControlContainer}>
      {skipBackButton}
      {
        isPlaying &&
        <TouchableOpacity onPress={pause}>
          <PauseIcon color={Theme.WHITE} {...musicControlIconSize} />
        </TouchableOpacity>
      }
      {
        !isPlaying &&
        <TouchableOpacity onPress={play}>
          <PlayIcon color={Theme.WHITE} {...musicControlIconSize} />
        </TouchableOpacity>
      }
      {skipForwardButton}
    </View>
  );
};

const styles = StyleSheet.create({
  musicControlContainer: {
    flexDirection: 'row',
    justifyContent: 'space-evenly',
    alignItems: 'center',
  },
});
